export const errors = {
  "404": "Seite nicht gefunden",
  "403": "Zugriff verweigert",
  "500": "Serverfehler",
  maintenance: "Wartungsmodus",
  goHome: "Zur Startseite",
};

export const errorPage = {
  title404: "404 - Seite nicht gefunden",
  subtitle404: "Die von Ihnen gesuchte Seite existiert leider nicht.",
  title403: "403 - Zugriff verweigert",
  subtitle403: "Sie haben nicht die erforderlichen Berechtigungen für diese Seite.",
  whatHappenedDesc403: "Die angeforderte Ressource darf mit Ihrem aktuellen Konto nicht aufgerufen werden.",
  reason403Login: "Melden Sie sich mit einem anderen Konto an oder kontaktieren Sie den Support.",
  title500: "500 - Interner Serverfehler",
  subtitle500: "Ein Fehler ist auf unserem Server aufgetreten.",
  whatHappenedDesc500: "Wir können diese Seite aufgrund eines unerwarteten Problems nicht anzeigen.",
  reason500Server: "Der Server hat unerwartet abgebrochen.",
  reason500Retry: "Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.",
  titleMaintenance: "Wartung - Kurzzeitig nicht erreichbar",
  subtitleMaintenance: "Das System wird momentan aktualisiert.",
  whatHappenedDescMaintenance: "Wir führen gerade Wartungsarbeiten durch.",
  reasonMaintenanceScheduled: "Geplante Systemwartung läuft.",
  reasonMaintenanceUpdates: "Wir bringen neue Funktionen und Verbesserungen online.",
  whatHappenedTitle: "Was ist passiert",
  whatHappenedDesc: "Die angeforderte Seite konnte nicht gefunden werden",
  reasonsIntro: "Dies kann verschiedene Gründe haben:",
  reasonWrongUrl: "Die URL wurde falsch eingegeben",
  reasonMoved: "Die Seite wurde verschoben oder gelöscht",
  reasonOutdated: "Der Link, dem Sie gefolgt sind, ist veraltet",
  reasonPermission: "Sie haben keine Berechtigung für diese Seite",
  goHome: "Zur Startseite",
  startSearch: "Suche starten",
  goBack: "Zurück",
  needHelpTitle: "Benötigen Sie Hilfe",
  needHelpText: "Wenn Sie glauben, dass dies ein Fehler ist oder weitere Unterstützung benötigen, können Sie sich an unser Support-Team wenden.",
  visitHelpCenter: "Hilfe-Center besuchen",
  contactSupport: "Support kontaktieren",
  quickLinksIntro: "Oder besuchen Sie eine dieser Seiten:",
  categories: "Kategorien",
  statistics: "Statistiken",
  myAccount: "Mein Account",
  administration: "Administration",
  login: "Anmelden",
};